import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import LeftSideBarNav from './components/LeftSideBarNav';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MenuLayout from './components/MenuLayout';
import MenuLayoutWithLoader from './components/MenuLayoutWithLoader';

import Home from "./pages/Home";
import Highlights from "./pages/Highlights";
import Views from "./pages/Views";
import Location from "./pages/Location";
import LocationNew from "./pages/LocationNew";
import Apartment from "./pages/Apartment";
import FloorPlans from "./pages/FloorPlan";
import Amenities from "./pages/Amenities";
import Inventory from './pages/Inventory';
import DayNight from './pages/DayNight';
import Tour360 from './pages/Tour360';

import RedirectToSurbhiInfotech from './pages/RedirectToSurbhiInfotech';
import HomeV2 from './pages/HomeV2';
import Tour360V2 from './pages/Tour360V2';
import World from './pages/World';
import HighlightsV2 from './pages/HighlightsV2';
import HomeCasaCeilo from './pages/HomeCasaCeilo';
import World2 from './pages/World2';
import Test from './pages/Test';
import SplashScreen from './pages/SplashScreen';
import { useState } from 'react';
import TilalHome from './pages/Tilal/TilalHome';
import TilalHomeV2 from './pages/Tilal/TilalHomeV2';
import MenuLayoutWithLoaderTilal from './components/MenuLayoutWithLoaderTilal';
import LotusHome from './pages/Lotus/LotusHome';
import TheAugusta2BHK from './pages/The_Augusta/TheAugusta2BHK';
import TheAugusta3BHK from './pages/The_Augusta/TheAugusta3BHK';
import TheAugusta3BHKCOP from './pages/The_Augusta/TheAugusta3BHKCOP';
import AugustaHome from './pages/The_Augusta/AugustaHome';
import GamaraOuter360 from './pages/Gamara/GamaraOuter360';
import GamaraOuter360High from './pages/Gamara/GamaraOuter360High';
import GamaraOuter360NightHigh from './pages/Gamara/GamaraOuter360NightHigh';
import GamaraOuter360NightLow from './pages/Gamara/GamaraOuter360NightLow';
import MarinaBay3BHK from './pages/MarinaBay/MarinaBay3BHK';
import MarinaBay4BHK from './pages/MarinaBay/MarinaBay4BHK';
import AllianceCity from './pages/Alliance_City/AllianceCity';
import CourtyardHome from './pages/Courtyard/CourtyardHome';
import CourtyardMenuLayout from './components/CourtyardMenuLayout';
import CourtyardTour360 from './pages/Courtyard/CourtyardTour360';
import CourtyardHighlights from './pages/Courtyard/CourtyardHighlights';
import CourtyardAmenities from './pages/Courtyard/CourtyardAmenities';
import CourtyardFloorPlan from './pages/Courtyard/CourtyardFloorPlan';
import CourtyardBrochure from './pages/Courtyard/CourtyardBrochure';
import CourtyardPaymentPlan from './pages/Courtyard/CourtyardPaymentPlan';
import MenuLayoutElysium from './components/MenuLayoutElysium';
import HomeElysiumTower from './pages/HomeElysiumTower';
import LocationElysiumTower from './pages/LocationElysiumTower';
import AmenitiesElysiumTower from './pages/AmenitiesElysiumTower';
import FloorPlanElysiumTower from './pages/FloorPlanElysiumTower';
import MenuLayoutSkyCrest8 from './components/MenuLayoutSkyCrest8';
import HomeSkyCrest8 from './pages/HomeSkyCrest8';
import Tour360SkyCrest8 from './pages/Tour360SkyCrest8';
import ViewsSkyCrest8 from './pages/ViewsSkyCrest8';
import LocationSkyCrest8 from './pages/LocationSkyCrest8';
import FloorPlanSkyCrest8 from './pages/FloorPlanSkyCrest8';
import BrochureSkyCrest8 from './pages/BrochureSkyCrest8';
import BrochureElysiumTower from './pages/BrochureElysiumTower';
import MasterLayoutElysiumTower from './pages/MasterLayoutElysiumTower';
import FloorPlanRamjiResidency from './pages/FloorPlanRamjiResidency';

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <div className="">
      <Router>
        <Routes>
          <Route path="/" element={<RedirectToSurbhiInfotech />} />
          <Route path="/tirupati-namaah" element={<MenuLayoutWithLoader splashDone={splashDone} setSplashDone={setSplashDone}> <Home /></MenuLayoutWithLoader>} />
          <Route path="/tirupati-namaah/day-night" element={<MenuLayout><DayNight /></MenuLayout>} />
          <Route path="/tirupati-namaah/highlights" element={<MenuLayout><Highlights /></MenuLayout>} />
          <Route path="/tirupati-namaah/views" element={<MenuLayout><Views /></MenuLayout>} />
          <Route path="/tirupati-namaah/location" element={<MenuLayout><Location /> </MenuLayout>} />
          <Route path="/tirupati-namaah/location-new" element={<MenuLayout><LocationNew /> </MenuLayout>} />
          <Route path="/tirupati-namaah/apartment" element={<MenuLayout><Apartment /></MenuLayout>} />
          <Route path="/tirupati-namaah/floorplans" element={<MenuLayout><FloorPlans /></MenuLayout>} />
          <Route path="/tirupati-namaah/amenities" element={<MenuLayout><Amenities /></MenuLayout>} />
          <Route path="/tirupati-namaah/inventory" element={<MenuLayout><Inventory /></MenuLayout>} />
          <Route path="/tirupati-namaah/360-tour" element={<MenuLayout><Tour360 /></MenuLayout>} />

          <Route path="/casa-ceilo" element={<MenuLayout><HomeCasaCeilo /></MenuLayout>} />


          <Route path="/tirupati-namaah/v2" element={<MenuLayout><HomeV2 /></MenuLayout>} />
          <Route path="/tirupati-namaah/highlights-v2" element={<MenuLayout><HighlightsV2 /></MenuLayout>} />
          <Route path="/tirupati-namaah/360-tour-v2" element={<MenuLayout><Tour360V2 /></MenuLayout>} />

          <Route path="/tirupati-namaah/world" element={<World />} />
          <Route path="/tirupati-namaah/world2" element={<World2 />} />
          <Route path="/tirupati-namaah/test" element={<Test />} />
          <Route path="/tirupati-namaah/welcome" element={<SplashScreen />} />

          <Route path="/tilal/v1" element={<TilalHome />} />
          <Route path="/tilal/" element={<MenuLayoutWithLoaderTilal splashDone={splashDone} setSplashDone={setSplashDone}> <TilalHomeV2 /></MenuLayoutWithLoaderTilal>} />

          <Route path="/lotus" element={<LotusHome />} />

          <Route path="/the_augusta/2bhk" element={<TheAugusta2BHK />} />
          <Route path="/the_augusta/3bhk" element={<TheAugusta3BHK />} />
          <Route path="/the_augusta/cop" element={<TheAugusta3BHKCOP />} />
          <Route path="/the_augusta/v1" element={<AugustaHome />} />

          <Route path="/gamara" element={<GamaraOuter360 />} />
          <Route path="/gamara-high" element={<GamaraOuter360High />} />
          <Route path="/gamara-night" element={<GamaraOuter360NightLow />} />
          <Route path="/gamara-night-high" element={<GamaraOuter360NightHigh />} />

          <Route path="/marina-bay/3bhk" element={<MarinaBay3BHK />} />
          <Route path="/marina-bay/4bhk" element={<MarinaBay4BHK />} />

          <Route path="/sea-breeze" element={<AllianceCity />} />

          <Route path="/courtyard" element={<CourtyardMenuLayout> <CourtyardHome /></CourtyardMenuLayout>} />
          <Route path="/courtyard/360-tour/" element={<CourtyardMenuLayout> <CourtyardTour360 /></CourtyardMenuLayout>} />
          <Route path="/courtyard/highlights/" element={<CourtyardMenuLayout> <CourtyardHighlights /></CourtyardMenuLayout>} />
          <Route path="/courtyard/amenities/" element={<CourtyardMenuLayout> <CourtyardAmenities /></CourtyardMenuLayout>} />
          <Route path="/courtyard/floorplans/" element={<CourtyardMenuLayout> <CourtyardFloorPlan /></CourtyardMenuLayout>} />
          <Route path="/courtyard/payment_plan/" element={<CourtyardMenuLayout> <CourtyardPaymentPlan /></CourtyardMenuLayout>} />
          <Route path="/courtyard/brochure/" element={<CourtyardMenuLayout> <CourtyardBrochure /></CourtyardMenuLayout>} />

          {/* Elysium Tower */}
          <Route path="/elysium-tower" element={<MenuLayoutElysium splashDone={splashDone} setSplashDone={setSplashDone}> <HomeElysiumTower /></MenuLayoutElysium>} />
          <Route path="/elysium-tower/master-layout" element={<MenuLayoutElysium><MasterLayoutElysiumTower /></MenuLayoutElysium>} />
          <Route path="/elysium-tower/location" element={<MenuLayoutElysium><LocationElysiumTower /> </MenuLayoutElysium>} />
          <Route path="/elysium-tower/amenities" element={<MenuLayoutElysium><AmenitiesElysiumTower /> </MenuLayoutElysium>} />
          <Route path="/elysium-tower/floorplans" element={<MenuLayoutElysium><FloorPlanElysiumTower /></MenuLayoutElysium>} />
          <Route path="/elysium-tower/brochure/" element={<MenuLayoutElysium> <BrochureElysiumTower /></MenuLayoutElysium>} />

          {/* SkyCrest8  */}
          <Route path="/sky-crest-8" element={<MenuLayoutSkyCrest8 splashDone={splashDone} setSplashDone={setSplashDone}> <HomeSkyCrest8 /></MenuLayoutSkyCrest8>} />
          <Route path="/sky-crest-8/day-night" element={<MenuLayoutSkyCrest8><DayNight /></MenuLayoutSkyCrest8>} />
          <Route path="/sky-crest-8/360-tour" element={<MenuLayoutSkyCrest8><Tour360SkyCrest8 /></MenuLayoutSkyCrest8>} />
          <Route path="/sky-crest-8/views" element={<MenuLayoutSkyCrest8><ViewsSkyCrest8 /></MenuLayoutSkyCrest8>} />
          <Route path="/sky-crest-8/location" element={<MenuLayoutSkyCrest8><LocationSkyCrest8 /></MenuLayoutSkyCrest8>} />
          {/* <Route path="/sky-crest-8/amenities" element={<MenuLayoutSkyCrest8><AmenitiesSkyCrest8 /> </MenuLayoutSkyCrest8>} /> */}
          <Route path="/sky-crest-8/floorplans" element={<MenuLayoutSkyCrest8><FloorPlanSkyCrest8 /></MenuLayoutSkyCrest8>} />
          <Route path="/sky-crest-8/brochure/" element={<MenuLayoutSkyCrest8> <BrochureSkyCrest8 /></MenuLayoutSkyCrest8>} />

          <Route path="/ramji-residency/floorplans" element={<FloorPlanRamjiResidency />} />

        </Routes>
      </Router>
    </div >
  );
}

export default App;
